/**
 * Resolves transfer line badges for map stop labels via the stop-lines mapping.
 */

import { stopLinesService } from "../../../../services/StopLinesService";
import type { StopLinesLookupOptions } from "../../../../services/stopLines.tools";
import type { GtfsRoute } from "../../../../types/Gtfs.types";

/**
 * Looks up correspondence routes for a stop id in the preloaded stop-lines mapping.
 *
 * @param stopId Prefixed or provider stop id from itinerary or realtime wire data.
 * @param options Optional GTFS source and parent station hints.
 * @returns Routes to display, or an empty array when lookup is unavailable.
 */
export function resolveStopCorrespondenceRoutes(
    stopId: string,
    options: StopLinesLookupOptions = {},
): readonly GtfsRoute[] {
    const trimmedStopId = stopId.trim();

    if ( trimmedStopId === "" || !stopLinesService.isReady() ) {
        return [];
    }

    return stopLinesService.getRoutesForStop( trimmedStopId, options );
}
